
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class Home extends Vue {
  async created() {
    await this.$router.push({name: 'Login'});
  }
}
